import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/index'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'/'el-icon-x' the icon show in the sidebar
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export let constantRoutes = [
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true,
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: '/dashboard',
        name: 'Dashboard',
        component: () => import('@/views/dashboard/index'),
        meta: {
          title: 'Bảng điều khiển',
          icon: 'dashboard',
        },
      },
    ],
  },
  {
    path: '/users',
    component: Layout,
    children: [
      {
        path: '/users',
        name: 'UserManagement',
        component: () => import('@/views/users/index'),
        meta: { title: 'Quản lý tài khoản', icon: 'user' },
      },
    ],
  },
  {
    path: '/payment-histories',
    component: Layout,
    children: [
      {
        path: '/payment-histories',
        name: 'Payment Histories',
        component: () => import('@/views/payment-histories/index'),
        meta: {
          title: 'Lịch sử giao dịch',
          icon: 'el-icon-finished',
        },
      },
    ],
  },
  {
    path: '/configs',
    component: Layout,
    children: [
      {
        path: '/configs',
        name: 'Configs',
        component: () => import('@/views/configs/index'),
        meta: { title: 'Cài đặt hệ thống', icon: 'el-icon-setting' },
      },
    ],
  },
  // 404 page must be placed at the end !!!
  {
    path: '/404',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'index',
        name: '404',
        component: () => import('@/views/404'),
      },
    ],
  },
  { path: '*', redirect: '/404', hidden: true },
]

const createRouter = () =>
  new Router({
    mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes,
  })

let router = createRouter()

router.beforeEach((to, from, next) => {
  store.dispatch('app/setPageLoading', true)
  next()
})

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
